import { ROUTE_PREFIXES } from '@/common/constants/route-prefixes';

const I = ROUTE_PREFIXES.institution;

/** Route patterns for router config (relative segments) */
export const institutionRoutePatterns = {
  dashboard: 'dashboard',
  users: 'users',
  groups: 'groups',
  billing: 'billing',
  notifications: 'notifications',
  profile: 'profile',
} as const;

/** Full paths for navigation (navigate, Link) */
export const institutionRoutes = {
  dashboard: `${I}/dashboard`,
  users: `${I}/users`,
  groups: `${I}/groups`,
  billing: `${I}/billing`,
  notifications: `${I}/notifications`,
  profile: `${I}/profile`,
} as const;
